/**
 * @module actions/carrental
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Getting overview for rentalcars
 * @return {Promise} Axios promise
 */
export function GetCarRentalOverview (data) {
  let url = API_URL + '/CarRental/Overview'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Move order to other car rental
 * @return {Promise} Axios promise
 */
export function MoveOrderCarRental (data) {
  let url = API_URL + '/CarRental/MoveOrder'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * Gets information about car availability
 * @param {Number} orderId
 */
export function GetAvailableCars (orderId, start, end) {
  let url = API_URL + '/CarRental/GetAvailableCars'
  let data = { OrderId: orderId, Start: start, End: end }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * Validates if a list of assigments are valid for an order
 * @param {Number} orderId
 * @param {Array} assignments - Array of: { CarRentalId, Start, End })
 */
export function ValidateAssignments (orderId, assignments) {
  let url = API_URL + '/CarRental/ValidateAssignments'
  let data = { OrderId: orderId, Assignments: assignments }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * Gets information about carrental assignments/periods
 * @param {Number} orderId
 * @param {Boolean} includeInactive
 */
export function GetAssignments (orderId, includeInactive, clearInactive = false) {
  let url = API_URL + '/CarRental/GetAssignments'
  let data = { OrderId: orderId, GetInactive: includeInactive, ClearInactive: clearInactive }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * Updates carrental assignments/periods
 * @param {Number} orderId
 * @param {Boolean} getInactive Set to true, to include inactive assignments/periods in response.
 * @param {Boolean} activate Set to true, to activate the passed in assignments.
 * @param {Array} Array of assignment objects. { PeriodId, CarRentalId, CarNumber, Identity, Start, End }
 */
export function UpdateAssignments (orderId, getInactive, activate, assignments) {
  let url = API_URL + '/CarRental/UpdateAssignments'
  let data = { OrderId: orderId, GetInactive: getInactive, Activate: activate, Assignments: assignments }
  return dispatch => {
    return axios.post(url, data)
  }
}

  /**
 * @description GetCarTypes from api
 * @return {Promise} Axios promise
 */
export function GetCarTypes () {
  let url = API_URL + '/CarRental/GetCarTypes'
  return dispatch => {
    return axios.get(url)
  }
}

  /**
 * @description GetCarClasses from api
 * @return {Promise} Axios promise
 */
export function GetCarClasses () {
  let url = API_URL + '/CarRental/GetCarClasses'
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/carrental.js